module.exports = __webpack_public_path__ + "img/ankara-sigorta.9838cbfc.jpg";